import Header from '../Fusion/Component/Header';
import ContactBox from '../Fusion/Component/Footer/ContactBox/Contactbox';
import HeadImage from '../Fusion/ContentElements/HeadImage';
import AccordionNavigation from '../Fusion/Component/AccordionNavigation/AccordionNavigation';

// load svg sprite
import loadSpriteSvgs from '../Fusion/Component/Sprite/LoadSprite';
loadSpriteSvgs();

import './Main.scss';

new Header;
new HeadImage;
new AccordionNavigation;
new ContactBox;

